import axios from "axios";

export default {
    namespaced: true,
    state: {
        cities: [],
    },
    mutations: {
        setCities(state, cities) {
            state.cities = cities
        }
    },
    actions: {
        search({commit}, {words, province}) {
            if (words.length) {
                words = {words: words}
                axios.post(`city/search/${province}`, words).then(res => {
                    const cities = res.data.data
                    commit('setCities', cities)
                })
            }
        }
    },
    getters: {
        getCities: state => state.cities
    }

}